/**
 * isIFrame returns true if we're loaded in an iframe.
 */
export const isIFrame = (): boolean => {
    try {
        // window.frameElement returns true if it's in a same-origin frame
        // but returns null if it's top-level or in a cross-origin situation.
        if (window.frameElement) {
            return true;
        }
        // In cross-origin scenarios accessing window properties may return
        // an error.
        return window.self !== window.top;
    } catch (e: any) {
        return true;
    }
};
